import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonUtilty, InteractService, LookupDataService, ApiRequestService } from 'app/BaseFramework';
import { DatePipe, TitleCasePipe  } from '@angular/common'
import { AppMetadataHandler } from 'app';
import { TechnicalTranslatePipe } from 'app/BaseFramework/shared/custom-pipes';
import { DataTransformService } from 'app/ViewModules/shared-services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { default as COLORS } from "app/BaseFramework/base-ui/ui-config/color-schemes.json";
import { NullLiteral } from 'typescript';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-underwriter-review',
  templateUrl: './underwriter-review.component.html',
  styleUrls: ['./underwriter-review.component.scss'],
  providers : [DatePipe, TitleCasePipe, TechnicalTranslatePipe]
})
export class UnderwriterReviewComponent implements OnInit {

  constructor(public datePipe: DatePipe,
    public titleCasePipe:TitleCasePipe,
    public technicalTranslatePipe: TechnicalTranslatePipe,
    public appMetadataHandler: AppMetadataHandler,
    public commonUtility: CommonUtilty,
    public dataTransformService: DataTransformService,
    private apiRequestService: ApiRequestService,
    private msg : NzMessageService) { }

  @Input() configData;
  @Input() inputDataForEdit;
  @Input() transactionState;
  @Input() policyData;
  @Input() RequirementEntityGuid; 

  @Output() emitStepToEnable = new EventEmitter<any>();
  listOfinsured: any[] = [];
  listOfPrimaryInsured: any[] = [];
  nomineelist: any[] = [];
  payerList: any[] = [];
  data_Cards : any[] = []


  launchDate;
  withdrawDate;
  ngOnInit(): void {
    this.fetchAllData();
    this.generateBasicDetails();
    this.updateAttributeBenefitExclusionDataCard();
    this.getClientsForEveryRole(this.policyData)
    this.fetchFraudDeatils();

  }
  isLoading : boolean = false;
  /* tslint:disable-next-line:no-any */
  log(args: any[]): void {
    console.log(args);
  }

  fraudDeatils = null;
  propensity = null;
  fraudScore = null; 
  modelPrediction
  recommendation
  fetchFraudDeatils(){
    let DO = this.commonUtility.getDOName(this.policyData)
    let pathVariables = [];
    pathVariables.push(this.policyData[DO].proposalNum);
    let url = 'fetchBatchLog'
    this.apiRequestService.getCallWithAPIMapper(url, null, null, pathVariables).subscribe(resp =>{
      if(resp.length > 0)
        this.fraudDeatils = resp
      else this.msg.error("Server Error : Please check with system administrator")

      if(this.fraudDeatils && this.commonUtility.isArrayIterable(this.fraudDeatils) && this.fraudDeatils.length){
        this.fraudDeatils.forEach(detail => {
          if(detail.batchName && detail.batchName == 'PROBABILITY'){
            let propensityRespData = this.commonUtility.deepCopy([JSON.parse(detail.responseData)]);
            this.propensity = propensityRespData[0] ? propensityRespData[0].claim_prediction_years ? propensityRespData[0].claim_prediction_years : null : null;
            this.dataTransformService.propensityRisk = this.propensity;
          }
          if(detail.batchName && detail.batchName == 'FWA_RISK'){
            let fraudScoreRespData = this.commonUtility.deepCopy([JSON.parse(detail.responseData)]);
           this.fraudScore = fraudScoreRespData[0] ? fraudScoreRespData[0].predictionProbabilityPercent ? fraudScoreRespData[0].predictionProbabilityPercent : null : null;
            this.modelPrediction = fraudScoreRespData[0] ? fraudScoreRespData[0].modelPrediction ? fraudScoreRespData[0].modelPrediction : null : null;
            this.dataTransformService.fraudRisk = this.modelPrediction;
            this.dataTransformService.fraudScore = this.fraudScore;
            this.recommendation = fraudScoreRespData[0] ? fraudScoreRespData[0].overallInvestigationRecommendation ? fraudScoreRespData[0].overallInvestigationRecommendation : null : null;
            this.dataTransformService.riskRecommendation = this.recommendation;
          }
          if(detail.batchName && detail.batchName == 'UW_RISK'){
            let UWRiskData = this.commonUtility.deepCopy([JSON.parse(detail.responseData)]);
            this.dataTransformService.riskSummary = UWRiskData[0]['content'] ? UWRiskData[0]['content'] : null;
            // this.modelPrediction = UWRiskData[0] ? UWRiskData[0].modelPrediction ? fraudScoreRespData[0].modelPrediction : null : null;
            // this.recommendation = UWRiskData[0] ? UWRiskData[0].overallInvestigationRecommendation ? fraudScoreRespData[0].overallInvestigationRecommendation : null : null;
          }
        })
        this.setCardsValues();
      } else {
        this.setCardsValues();
      }
    })
  }

  setCardsValues(){
    this.data_Cards = [
      {
        "name": "Proposal Details",
        "icon" : "bars",
        // "desc" : "",
        "filterBasedOn" : "proposalDetails",
        "path" : "attributeList"
      },
      {
        "name": "Medical Risk",
        "value": 0,
        "icon" : "bars",
        // "desc" : "<ul style='list-style: circle;'><li>Morbidity risk</li><li>Claim Propensity Score</li></ul>",
        "filterBasedOn" : "vocabularyCd",
        "path" : "attributeList",
        "summary" : "The individual's Medical Risk Score of 12 indicates a moderate level of risk for various health outcomes. The Morbidity Risk component suggests a likelihood of developing certain medical conditions, while the Claim Propensity Score indicates a moderate likelihood of filing health insurance claims. This score prompts healthcare providers and insurers to focus on preventive measures, targeted interventions, and resource allocation to address potential health issues and manage financial risks effectively."
      },
      {
        "name": "Underwriting Risk",
        "value": this.dataTransformService.riskSummarizationResponse ? this.dataTransformService.riskSummarizationResponse.overall_risk ? this.dataTransformService.riskSummarizationResponse.overall_risk : 0 : 0,
        "icon" : "file-add",
        // "desc" : "<ul style='list-style: circle;'><li>Lifestyle Risk</li><li>​Financial Risk</li><li>​Occupational Risk</li><li>​Environmental Risk</li></ul>​",
        "filterBasedOn" : "riderCd",
        "path" : "productRiderAssociationList",
        "summary" : "An Underwriting Risk Score of 41 indicates a moderate level of overall risk for the individual. The Lifestyle Risk component suggests that the individual has moderate lifestyle-related factors that may influence health. Financial Risk analysis indicates a moderate level of financial stability, while Occupational Risk suggests a moderate exposure to job-related hazards. Environmental Risk assessment points to a moderate level of environmental factors that could impact health. Insurers can use this composite score to tailor insurance policies, determining premiums and coverage terms that reflect the individual's moderate risk profile."
      },
      {
        "name": "Fraud Risk",
        "value": this.dataTransformService.fraudRisk ? this.dataTransformService.fraudRisk : 0,
        "icon" : "issues-close",
        // "desc" : "<ul style='list-style: circle;'><li>Individual</li><li>​Intermediary</li><li>​Collision</li></ul>​",
        "filterBasedOn" : "exclusionType",
        "path" : "productLoadingExclusionList",
        "summary" : "A Fraud Risk Score of 12 suggests a relatively low overall risk level for fraudulent activities. The Individual Risk component indicates a low likelihood of fraudulent behavior by the primary party involved. Intermediary Risk suggests that third-party entities or intermediaries associated with the transactions have a low risk of involvement in fraudulent activities. Additionally, the Collision Risk component implies a low potential for coordinated fraudulent schemes between multiple parties. Financial and insurance institutions can use this low score to streamline their risk management strategies, focusing resources on areas with higher potential risks while maintaining vigilance across all aspects of their operations."
      },
      {
        "name": "Portfolio Impact",
        "moreInfo": "Low",
        "icon" : "exception",
        // "desc" : "<ul style='list-style: circle;'><li>Portfolio Insights</li></ul>​",
        "filterBasedOn" : "exclusionType",
        "path" : "productLoadingExclusionList",
        "summary" : "The Portfolio Impact Score of 5 suggests a moderate overall impact and performance for the financial portfolio. The Portfolio Insights subcomponent, which contributed to this score, provides a comprehensive analysis of the assets, securities, and investments within the portfolio. This moderate score indicates a balanced and stable portfolio with a careful consideration of factors such as asset allocation, diversification, historical performance, and market trends. Investors can use this information to make well-informed decisions, optimize their asset allocation strategy, and ensure that their portfolio aligns with their financial objectives and risk preferences."
      },
      {
        "name": "Risk Improvement",
        "moreInfo": "Applicable for Renewal",
        "icon" : "exception",
        // "desc" : "<ul style='list-style: circle;'><li>Impact of Risk Management Program</li></ul>​",
        "filterBasedOn" : "exclusionType",
        "path" : "productLoadingExclusionList",
        "summary" : "A Risk Improvement Score of 2 suggests that there is either no discernible impact or improvement resulting from the implemented risk management program. In this context, the Impact of Risk Management Program subpoint indicates that the risk management strategies have not yet demonstrated effectiveness in reducing overall risk.This situation may prompt a reassessment of the risk management program, as a score of 0 implies that the existing strategies may not be effectively mitigating risks or that improvements are needed. Stakeholders should carefully review and potentially revise their risk management measures to ensure they are aligned with the organization's goals and adequately address the identified risks. This process may involve identifying areas for enhancement, refining strategies, and implementing additional measures to enhance the overall effectiveness of the risk management program."
      }
    ];
  }

  primaryInsured = null;
  getClientsForEveryRole(IO) {
    if(IO){
      this.listOfPrimaryInsured = this.commonUtility.extractClientDOFromIOGeneric(IO, 'PRIMARYINSURED');
      this.primaryInsured = this.listOfPrimaryInsured ? this.listOfPrimaryInsured[0] ? this.listOfPrimaryInsured[0] : null : null
      this.listOfinsured = this.commonUtility.extractClientDOFromIOGeneric(IO, 'INSURED')
      console.log("primary insured list", this.listOfPrimaryInsured);
      console.log("insured list", this.listOfinsured);
      this.nomineelist = this.commonUtility.extractClientDOFromIOGeneric(IO, 'NOMINEE')
      this.payerList = this.commonUtility.extractClientDOFromIOGeneric(IO, 'PAYER')
    }
  }

  fetchAllData(){
    if(this.inputDataForEdit && this.inputDataForEdit.productDO){
      this.isLoading = true;
    let payload = {
        "size": "1000",
        "searchCriteriaList": [
          {
            "paramName": "guid",
            "paramValue": this.inputDataForEdit.productDO.guid
          }
        ]
    };

    let url = "api/product/worksheet/fetch";
      this.apiRequestService.postCallWithAPIMapper(url, payload).subscribe(resp => {
        if (resp) {
          this.productSummaryData = resp;
          this.data_Cards =  [...this.data_Cards, ...this.getCardsData(this.productSummaryData)];
        }
        else{
          //this.msg.error('Server Error - Technical issue occurred, please contact IT Support.')
        }
        this.isLoading = false;
      })
    }
  }

  generateBasicDetails(){
    if(this.inputDataForEdit && this.inputDataForEdit.productDO){
      let productDO = this.inputDataForEdit.productDO;
      this.launchDate = productDO['launchDt'] ? this.datePipe.transform(this.commonUtility.serverDOtoUIDODate(productDO['launchDt']) ,this.appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : '-';
      this.withdrawDate =  productDO['withdrawDt'] ? this.datePipe.transform(this.commonUtility.serverDOtoUIDODate(productDO['withdrawDt']) ,this.appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : '-';
      this.basicDetails = {
          title : "Basic Information",
          data : [
            {
              title : "Product Name" ,
              value : productDO['productName'] ? this.titleCasePipe.transform(productDO['productName']) :  '-',
              visibleWith : 'PRODUCT, COVERAGE, BENEFIT'
            },
            {
              title : "Product Marketing Name" ,
              value : productDO['productMarketingName'] ? this.titleCasePipe.transform(productDO['productMarketingName']) :  '-',
              visibleWith : 'PRODUCT, COVERAGE, BENEFIT'
            },
            {
              title : "Version" ,
              value : productDO['productVersion'] || '-',
              visibleWith : 'PRODUCT, COVERAGE, BENEFIT'
            },
            {
              title : "Business Version" ,
              value : productDO['businessVersion'] || '-',
              visibleWith : 'PRODUCT, COVERAGE, BENEFIT'
            },
            {
              title : "Regulator ID" ,
              value : productDO['regulatorProductCd'] ||  '-',
              visibleWith : 'PRODUCT, COVERAGE, BENEFIT'
            },
            {
              title : "Plan Code" ,
              // value : this.dataTransformService.planCode ? this.dataTransformService.planCode : '-',
              visibleWith : 'PRODUCT'
            },
            {
              title : "Product Type" ,
              // value : this.dataTransformService.productTypeCd ? this.technicalTranslatePipe.transform(this.dataTransformService.productTypeCd.toString()) :  '-',
              // value : this.dataTransformService.productTypeCd ? this.dataTransformService.productTypeCd : '-',
              visibleWith : 'PRODUCT',
              type : 'csv'
            },
            {
              title : "Plan Options" ,
              // value : this.dataTransformService.productOptions ? this.technicalTranslatePipe.transform(this.dataTransformService.productOptions.toString()) :  '-',
              // value : this.dataTransformService.productOptions ? this.dataTransformService.productOptions : '-',
              visibleWith : 'PRODUCT',
              type : 'csv'
            },
            {
              title : "Underwriting Type" ,
              value : productDO['underwitingTypeCd'] ? this.technicalTranslatePipe.transform(productDO['underwitingTypeCd']) :  '-',
              visibleWith : 'PRODUCT'
            },
            {
              title : "Adjudication Type" ,
              value : productDO['adjudicationTypeCd'] ? this.technicalTranslatePipe.transform(productDO['adjudicationTypeCd']) :  '-',
              visibleWith : 'PRODUCT'
            },
            {
              title : "Generic Group Code" ,
              value : productDO['genericGroupCd'] ? this.technicalTranslatePipe.transform(productDO['genericGroupCd']) :  '-',
              visibleWith : 'PRODUCT, COVERAGE, BENEFIT'
            },
            {
              title : "Submission Type" ,
              value : productDO['submissionModeCSV'] ? this.technicalTranslatePipe.transform(productDO['submissionModeCSV']) :  '-',
              visibleWith : 'PRODUCT'
            }/*,
            {
              title : "Launch Date",
              value : productDO['launchDt'] ? this.datePipe.transform(productDO['launchDt'] ,this.appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : '-',
              visibleWith : 'PRODUCT, COVERAGE, BENEFIT'
            },
            {
              title : "Withdraw Date" ,
              value : productDO['withdrawDt'] ? this.datePipe.transform(productDO['withdrawDt'] ,this.appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : '-',
              visibleWith : 'PRODUCT, COVERAGE, BENEFIT'
            }*/
          ]
      }
    }
  }

  exclusionList = [];
  updateAttributeBenefitExclusionDataCard(){
      if(this.inputDataForEdit && this.inputDataForEdit.productDO){
        if(this.commonUtility.isArrayIterable(this.inputDataForEdit.productDO['attributeList'])){
          this.data_Cards.find(item => item.name == 'Attributes').value = this.inputDataForEdit.productDO['attributeList'].length;
        }
        // if(this.commonUtility.isArrayIterable(this.inputDataForEdit.productDO['eventBenefitMapDOList'])){
        //   this.data_Cards.find(item => item.name == 'Benefits').value = this.inputDataForEdit.productDO['eventBenefitMapDOList'].length ;
        // }
        // if(this.commonUtility.isArrayIterable(this.inputDataForEdit.productDO['productRiderAssociationList'])){
        //   this.data_Cards.find(item => item.name == 'Coverages').value = this.inputDataForEdit.productDO['productRiderAssociationList'].length
        // }
        if(this.commonUtility.isArrayIterable(this.inputDataForEdit.productDO['productLoadingExclusionList'])){
          this.data_Cards.find(item => item.name == 'Exclusions').value = this.inputDataForEdit.productDO['productLoadingExclusionList'].length;
        }
        //Generate Exclusions list
        if(this.commonUtility.isArrayIterable(this.inputDataForEdit.productDO['productLoadingExclusionList'])){
          this.exclusionList = this.generateExclusionList(this.inputDataForEdit.productDO['productLoadingExclusionList']);
        }
      }
  }

  generateExclusionList(exclusion_list){
    let tempExclusionArray = [];
    if(this.commonUtility.isArrayIterable(exclusion_list)){
      exclusion_list.forEach(element => {
        const obj = {
          exclusionType : element.exclusionType,
          type: this.getExclusionTypeData(element.exclusionType, element),
          causeOfEventCd : element.causeOfEventCd,
          validityType : element.validityType,
          periodUnit: element.periodUnit,
          periodValue : element.periodValue,
          ruleCd : element.ruleCd
        }
        tempExclusionArray.push(obj);
      });
    }
    return tempExclusionArray;
  }

  getExclusionTypeData(exclusionType,element){
    let ex_type = element.categoryCd;
    switch (exclusionType) {
      case "COVERAGEBASED":
        ex_type = element.riderCd
        break;
      case "EVENTBASED":
        ex_type = element.eventTypeCd
        break;
      case "ICDBASED":
        ex_type = element.icdCode
        break;
      case "PCSBASED":
        ex_type = element.icdCode
        break;
    }
    return ex_type;
  }

  getCardsData(productSummaryData: any): any {
    const transformedData: any = [];
  
    for (const key in productSummaryData) {
      if (Object.prototype.hasOwnProperty.call(productSummaryData, key)) {
        transformedData.push({
          name : key.toLowerCase(),
          value : this.commonUtility.isArrayIterable(productSummaryData[key]) ? productSummaryData[key].length : [],
          icon : this.data_Cards_additionalDataMap[key.toUpperCase()] ? this.data_Cards_additionalDataMap[key.toUpperCase()].icon : 'file-done',
          desc : this.data_Cards_additionalDataMap[key.toUpperCase()] ? this.data_Cards_additionalDataMap[key.toUpperCase()].desc : null,
          filterBasedOn : this.data_Cards_additionalDataMap[key.toUpperCase()] ? this.data_Cards_additionalDataMap[key.toUpperCase()].filterBasedOn : null,
        })
      }
    }
  
    return transformedData;
  }
  
  productSummaryData = {};


  activeCardIndex: number = -1; 
  activeEntityName: string = null;
  filterBasedOn = null;
  listConfiguration: any;
  showDetailedDataSection: boolean = false;
  selectedCardSummary : string = null
  titlecase : string = null
  showDetailedData(index, item) {
    if(item.value && item.value > 0 && this.activeCardIndex != index){
      this.activeCardIndex = index;
      this.activeEntityName = item.name.toLowerCase();
      this.filterBasedOn = item.filterBasedOn;
      if(item.path && this.inputDataForEdit && this.inputDataForEdit.productDO){
        this.showCardDetails = this.inputDataForEdit.productDO[item.path]
      }else{
        this.showCardDetails = this.productSummaryData[item.name.toUpperCase()];
      }
      this.listConfiguration = this[item.name.toLowerCase() + '_Config'];
      this.selectedCardSummary = item.summary
      this.titlecase = item.name
      this.refreshDetailDataSection();
      //this.filterCriteria = card['filterCriteria'];
      //this.showCardHeaders = card['cardHeaders'];
      //this.currentCardIndex = index;
    }
    else{
      this.activeCardIndex = index;
      this.activeEntityName = item.name.toLowerCase();
      this.refreshDetailDataSection();
    }
  }

  refreshDetailDataSection(){
    this.showDetailedDataSection = !this.showDetailedDataSection;
    // setTimeout(() => { this.showDetailedDataSection = !this.showDetailedDataSection; }, 300);
  }

  showCardDetails : any[] =[]
  filterCriteria : any[] =[]
  showCardHeaders : any[] =[]
  currentCardIndex :number;

  // onCardChange(item, index){
  //   this.dataCARDS.forEach(card =>{
  //     if(card.name == item.name){
  //       this.showCardDetails = card.cardData;
  //       this.filterCriteria = card['filterCriteria'];
  //       this.showCardHeaders = card['cardHeaders'];
  //       this.currentCardIndex = index;
  //     }
  //   })
  // }

 /* ====================================== */
  /* UI COLOR SCHEME SELECTION AND SETTING  */
  /*colorSchemes = COLORS;
  colorSchemesNames = COLORS.map(i=>i.name);
  colorScheme = {
    name: 'horizon',
    selectable: true,
    group: 'Continuous',
    domain: COLORS.find(i=>i.default).scheme,
  };
  colorSchemeTempModel:any = COLORS.findIndex(i=>i.default);
  colorSchemeModelChange() {
    let temp = this.colorScheme;
    temp['domain'] = this.colorSchemes[this.colorSchemeTempModel].scheme;
    this.colorScheme = Object.assign({}, temp);
    // this.onCardChange(900); 
  }*/
  /* ====================================== */

  redirectToStep(){
    if(this.activeEntityName == 'attributes'){
      this.emitStepToEnable.emit('attributes');
    }
    else if(this.activeEntityName == 'benefits'){
      this.emitStepToEnable.emit('benefits');
    }
    else if(this.activeEntityName == 'exclusions'){
      this.emitStepToEnable.emit('exclusions');
    }
    else if(this.activeEntityName == 'coverages'){
      this.emitStepToEnable.emit('coverages');
    }
  }

  basicDetails = {};

  basicDetailsJSON : any[] =[
    {
      "fieldName" : "Name",
      "fieldValue" : "Dummy Product For Product Analytics"
    },
    {
      "fieldName" : "Marketing Name",
      "fieldValue" : "Dummy Product For Product Analytics"
    },
    {
      "fieldName" : "Version",
      "fieldValue" : "2"
    },
    {
      "fieldName" : "Regulator Id",
      "fieldValue" : "HN"
    },
    {
      "fieldName" : "Product Type",
      "fieldValue" : "Individual"
    },
    {
      "fieldName" : "Claimed Amount",
      "fieldValue" : "Rs. 13450"
    }
  ]

  data_Cards_additionalDataMap = {
    "RULES" : {
      "icon" : "file-done",
      "desc" : "All the <span class='f-w-700'>Rules</span> that capture decision logic in this Product",
      "filterBasedOn" : "serviceType",
    },
    "VOCABULARIES" : {
      "icon" : "book",
      "desc" : "The <span class='f-w-700'>Vocabularies</span> used as building blocks of this Product",
      "filterBasedOn" : "vocabularyType"
    }, 
    "LOOKUPS" : {
      "icon" : "setting",
      "desc" : "All the <span class='f-w-700'>Lookups</span> leveraged to standardize data within the Product",
      "filterBasedOn" : "lookupType"
    },
    "COVERAGES" : {
      "icon" : "setting",
      "desc" : "All the <span class='f-w-700'>Coverages</span> leveraged to standardize data within the Product",
      "filterBasedOn" : "associationTypeCd"
    },
    "BENEFITS" : {
      "icon" : "setting",
      "desc" : "All the <span class='f-w-700'>Benefits</span> leveraged to standardize data within the Product",
      "filterBasedOn" : ""
    }
  }

  rules_Config = {
    "title": "Rules",
    "listHeader": [
      {
        "header": "Name",
        "key": "displayName",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "width": "500px"
      },
      {
        "header": "Purpose",
        "key": "service",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "width": "250px",
        "pipe": true
      },
      {
        "header": "Type",
        "key": "serviceType",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "width": "250px",
        "pipe": true
      }
    ]
  }
  lookups_Config = {
    "title": "Lookups",
    "listHeader": [
      {
        "header": "Name",
        "key": "name",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "width": "500px"
      },
      {
        "header": "Type",
        "key": "lookupType",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "width": "250px",
        "pipe": true
      },
      {
        "header": "guid",
        "key": "guid",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": false,
        "width": "250px"
      }
    ]
  }
  vocabularies_Config = {
    "title": "Vocabularies",
    "listHeader": [
      {
        "header": "Name",
        "key": "vocabularyName",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "width": "500px"
      },
      {
        "header": "Type",
        "key": "vocabularyType",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "width": "250px",
        "pipe": true
      },
      {
        "header": "guid",
        "key": "guid",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": false,
        "width": "250px"
      }
    ]
  }
  benefits_Config = {
    "title": "Benefits",
    "listHeader": [
      // {
      //   "header": "Benefit Name",
      //   "key": "benefitId",
      //   "searchFilter": true,
      //   "sortFilter": true,
      //   "isVisible": true,
      //   "pipe": true
      // },
      // {
      //   "header": "Event",
      //   "key": "eventCd",
      //   "searchFilter": true,
      //   "sortFilter": true,
      //   "isVisible": true,
      //   "pipe": true
      // },
      // {
      //   "header": "Entity",
      //   "key": "entityCd",
      //   "searchFilter": true,
      //   "sortFilter": true,
      //   "isVisible": true,
      //   "pipe": true
      // },
      // {
      //   "header": "Event Frequency",
      //   "key": "eventFrequencyCd",
      //   "searchFilter": true,
      //   "sortFilter": true,
      //   "isVisible": true,
      //   "pipe": true
      // },
      // {
      //   "header": "Event Tenure",
      //   "key": "eventTenureCd",
      //   "searchFilter": true,
      //   "sortFilter": true,
      //   "isVisible": true,
      //   "pipe": true
      // },
      {
        "header": "Benefit Name",
        "key": "productName",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "pipe": true
      },
      {
        "header": "Benefit Marketing Name",
        "key": "marketingName",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "pipe": true
      },
      {
        "header": "Version",
        "key": "productVersion",
        "searchFilter": true,
        "sortFilter": false,
        "isVisible": true,
        "pipe": false
      }
    ]
  } 
  coverages_Config = {
    "title": "Coverages",
    "listHeader": [
      {
        "header": "Coverage Name",
        "key": "productName",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "pipe": true
      },
      {
        "header": "Coverage Marketing Name",
        "key": "marketingName",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "pipe": true
      },
      {
        "header": "Version",
        "key": "productVersion",
        "searchFilter": true,
        "sortFilter": false,
        "isVisible": true,
        "pipe": false
      }
      // {
      //   "header": "Benefits Mapped",
      //   "key": "productRiderBenefitList",
      //   "showLength" : true,
      //   "searchFilter": true,
      //   "sortFilter": true,
      //   "isVisible": true,
      //   "pipe": false
      // }
    ]
  }
  benefits1_Config = {
    "title": "Coverages",
    "listHeader": [
      {
        "header": "Coverage Name",
        "key": "productName",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "pipe": true
      },
      {
        "header": "Coverage Marketing Name",
        "key": "productMarketingName",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "pipe": true
      },
      {
        "header": "Version",
        "key": "productVersion",
        "searchFilter": true,
        "sortFilter": false,
        "isVisible": true,
        "pipe": false
      }
    ]
  }
  attributes_Config = {
    "title": "Attributes",
    "listHeader": [
      {
        "header": "Attribute Name",
        "key": "vocabularyCd",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "pipe": true
      },
      {
        "header": "Lookup",
        "key": "allowedLookupsCSV",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true
      }
    ]
  } 

  exclusions_Config = {
    "title": "Exclusions",
    "listHeader": [
      {
        "header": "Type",
        "key": "exclusionType",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "pipe": true
      },
      {
        "header": "Lookup",
        "key": "allowedLookupsCSV",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "pipe": true
      }
    ]
  } 

personDetailsToShow = [
  {
    "fieldValue" : "Name",
    "fieldKey" : "name"
  },
  {
    "fieldValue" : "DOB",
    "fieldKey" : "dob"
  },
  {
    "fieldValue" : "Gender",
    "fieldKey" : "genderCd",
    "pipe" : "technicalTranslate"
  },
  {
    "fieldValue" : "Email ID",
    "fieldKey" : "preferredEmail"
  },
  {
    "fieldValue" : "Mobile No.",
    "fieldKey" : "preferredMobileNum"
  },
  {
    "fieldValue" : "Occupation",
    "fieldKey" : "occupationCd",
    "pipe" : "technicalTranslate"
  },
  {
    "fieldValue" : "Annual Income",
    "fieldKey" : "annualIncome",
    "pipe" : "CurrencyFormatter"
  },
  {
    "fieldValue" : "Cibil Score",
    "fieldKey" : "cibilScore"
  },
  {
    "fieldValue" : "BMI",
    "fieldKey" : "bmi"
  },
  {
    "fieldValue" : "Post Code",
    "fieldKey" : "postCode"
  }, 
  {
    "fieldValue" : "City",
    "fieldKey" : "city",
    "pipe" : "technicalTranslate"
  },
  {
    "fieldValue" : "Citizenship",
    "fieldKey" : "citizenshipCd",
    "pipe" : "technicalTranslate"
  },
  {
    "fieldValue" : "Address",
    "fieldKey" : "preferredAddress"
  }
]

  tempInsuredList = [
    {
      "name" : "John Doe",
      "roleCd" : "PRIMARY",
      "gender" : "Male",
      "DOB" : "15 Dec 1990",
      "weight" : 58,
      "height" : 165,
      "address" : "11-A,riTown,opp-Mall, Hanoi, Hanoi, Vietnam, 65665"
    }
  ]

}
